import * as React from 'react';
import { cn } from '../../utils/ClassNamesUtils';

// Shared stat-card shell (Figma .card(legacy)): white, 1px grey-5 border, 2px
// radius, 16/12 padding. Inner layout differs per card, passed via className.
// Used by the deliverable detail pane and the project overview.
export const OWStatCard = ({
	children,
	className,
}: {
	children: React.ReactNode;
	className?: string;
}) => (
	<div
		className={cn(
			'flex-1 rounded-[2px] border border-solid border-grey-5 bg-white px-4 py-3',
			className
		)}
	>
		{children}
	</div>
);

export default OWStatCard;
